import React from "react"
import {Row, Col} from "react-bootstrap"
import Card from "@irati/ui/src/Layout/Card"

import successLogos from "@irati/ui/images/success-logos.svg"
import Hr from "@irati/ui/src/Layout/Hr"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {FormattedMessage} from "@irati/utils/lang"

import "./styles/Finished.css"

const DealSuccessFinished = () => {
  return (
    <Row className="dealSuccessFinished">
      <Col md={12}>
        <Card>
          <Row>
            <Col sm={6} xs={12}>
              <h4 className="codeHeader">
                <FormattedMessage id="perks.containers.dealSuccess.finished.header" />
              </h4>
              <Hr solid />
              <ButtonRouterLink to="/" className="dealSuccessFinished_link">
                <FormattedMessage id="perks.containers.dealSuccess.finished.back" />
              </ButtonRouterLink>
            </Col>
            <Col sm={2} xsHidden />
            <Col sm={4} xsHidden>
              <img src={successLogos} alt="success" />
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  )
}

export default DealSuccessFinished
